<template>
    <div>
        <div class="list" v-if="tableData && tableData.length > 0">
            <div class="item" v-for="(item, index) in tableData" :key="index">
                <div class="title">
                    <div class="left">
                        <!-- <a :href="nameClick(item)" target="_blank"> -->
                        <a target="_blank">
                            {{item[name]}}
                        </a>
                    </div>
                </div>

                <div class="cont">
                    <p v-html="item.answer" style="fontSize:14px;"></p>
                </div>

                <div class="desc" v-if="showTag">
                    <div class="left">
                        <div class="tag" v-if="item.area">{{item.area}}</div>
                        <div class="tag" v-if="item.noticetype">{{item.noticetype}}</div>
                    </div>
                    <div class="right">
                        <div class="tag"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 为空 -->
        <div v-else>
            <div v-if="loading" class="loading">
                <div v-for="i in 10" :key="i" class="item">
                    <el-skeleton animated>
                        <template #template>
                            <div class="skeleton">
                                <el-skeleton-item variant="text" style="width: 80%; height: 24px; marginRight: 5%;" />
                                <el-skeleton-item variant="text" style="width: 15%; height: 24px;" />
                            </div>

                            <div class="skeleton" v-if="showTag">
                                <el-skeleton-item variant="text" style="width: 7%; height: 24px; marginRight: 5%;" />
                                <el-skeleton-item variant="text" style="width: 12%; height: 24px; marginRight: 5%;" />
                                <el-skeleton-item variant="text" style="width: 4%; height: 24px;" />
                            </div>
                        </template>
                    </el-skeleton>
                </div>

            </div>
            <div v-else>
                <el-empty :image-size="200"></el-empty>
            </div>
        </div>

    </div>
</template>

<script>


export default {
    props: {
        tableData: {
            type: Array,
            default: () => { return []; }
        },
        //是否显示标签
        showTag: {
            type: Boolean,
            default: false,
        },
        // 是否正在请求数据
        loading: {
            type: Boolean,
            default: true,
        },

        //
        name: {
            type: String,
            default: 'title',
        },
        time: {
            type: String,
            default: 'publishtime',
        },
        // 生成 跳转链接
        createUrl: {
            type: Function,
            default: function () { }
        },
        afterQuery: {
            type: Function,
            default: function () { }
        },
    },
    name: '',

    data () {
        return {
        };
    },
    mounted () {

    },
    methods: {
        nameClick (item) {
            if (!!this.createUrl) {
                return this.createUrl(item);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.skeleton {
    display: flex;
    justify-items: space-between !important;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    height: 24px;
}

.list {
    margin-bottom: 40px;

    .item {
        border-bottom: solid 1px #d6d6d6;
        padding-top: 30px;
        padding-bottom: 25px;

        .title {
            display: flex;
            color: #1b1b1b;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 18px;

            a {
                color: #1b1b1b;

                &:hover {
                    color: $primaryColor;
                }
            }

            .left {
                font-size: 18px;
                // width: calc(100% - 200px);
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .right {
                width: 200px;
                text-align: right;
                font-size: 16px;
            }
        }

        .desc {
            display: flex;
            align-items: center;

            .left {
                flex: 1;
                display: flex;
                align-items: center;

                .tag {
                    color: $primaryColor;
                    background-color: $primaryColor2;
                    line-height: 1em;
                    padding: 4px 16px;

                    & + .tag {
                        margin-left: 10px;
                    }
                }
            }

            .right {
                font-size: 16px;
                color: #888888;
            }
        }

        & + .item {
            margin-top: 15px;
        }
    }
}

.loading {
    .item {
        border-bottom: solid 1px #d6d6d6;
        padding-top: 30px;
        padding-bottom: 25px;
    }
}
</style>
